"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrpcClient = void 0;
var bt_rpc_base_1 = require("bt-rpc-base");
var debug = console.debug;
var transport_1 = require("./http/transport");
var GrpcClient = (function () {
    function GrpcClient(fullUrl, onHeaders, onMessage, onEnd, withCredentials, debug) {
        this.closed = false;
        this.debug_ = debug ? true : false;
        this.onEnd_ = onEnd;
        this.onMessage_ = onMessage;
        this.onHeaders_ = onHeaders;
        var transportOptions = {
            debug: this.debug_,
            url: fullUrl,
            withCredentials: withCredentials || false,
            onHeaders: this.onTransportHeaders.bind(this),
            onChunk: this.onTransportChunk.bind(this),
            onEnd: this.onTransportEnd.bind(this),
        };
        this.transport = (0, transport_1.makeDefaultTransport)(transportOptions);
    }
    GrpcClient.prototype.onTransportHeaders = function (headers, status) {
        this.debug_ && debug('onHeaders', headers, status);
        if (!this.closed && status !== 0) {
            this.responseHeaders = headers;
            var _a = (0, bt_rpc_base_1.parseStatus)(headers), gRPCStatus = _a[0], msg = _a[1];
            this.rawOnHeaders(headers);
            if (gRPCStatus) {
                this.rawOnError(gRPCStatus, msg, headers);
            }
        }
    };
    GrpcClient.prototype.onTransportChunk = function (fullBody) {
        if (this.closed || !fullBody) {
            this.debug_ && debug('onChunk.close or null body , ignore');
            return;
        }
        var _a = (0, bt_rpc_base_1.parseBodyFrame)(new Uint8Array(fullBody)), data = _a[0], trailer = _a[1];
        this.rawOnMessage(data);
        if (trailer) {
            this.responseTrailers = (0, transport_1.http1ResToMeta)(trailer);
            this.debug_ && debug('onChunk.trailers', this.responseTrailers);
        }
    };
    GrpcClient.prototype.onTransportEnd = function (err) {
        if (this.closed) {
            this.rawOnError(bt_rpc_base_1.GrpcStatusCode.DEADLINE_EXCEEDED, 'request closed');
            return;
        }
        this.closed = true;
        var resHeaders = this.responseTrailers || this.responseHeaders;
        if (!resHeaders || err) {
            this.rawOnError(bt_rpc_base_1.GrpcStatusCode.UNKNOWN, 'Response ended without headers,' + (err === null || err === void 0 ? void 0 : err.message));
            return;
        }
        this.debug_ && debug('grpc.onEndWithHeaders: ', resHeaders);
        var _a = (0, bt_rpc_base_1.parseStatus)(resHeaders), gRPCStatus = _a[0], msg = _a[1];
        if (gRPCStatus === undefined) {
            this.rawOnError(bt_rpc_base_1.GrpcStatusCode.INTERNAL, 'Response closed without grpc-status (Trailers provided)');
            return;
        }
        if (!this.onEnd_)
            return;
        this.onEnd_(gRPCStatus, msg, resHeaders);
    };
    GrpcClient.prototype.rawOnHeaders = function (headers) {
        this.debug_ && debug('rawOnHeaders', headers);
        if (this.onHeaders_)
            this.onHeaders_(headers);
    };
    GrpcClient.prototype.rawOnError = function (code, msg, trailers) {
        this.debug_ && debug('rawOnError', code, msg);
        if (this.onEnd_)
            this.onEnd_(code, msg, trailers);
    };
    GrpcClient.prototype.rawOnMessage = function (res) {
        this.debug_ && debug('rawOnMessage with len :', res.length);
        if (this.onMessage_)
            this.onMessage_(res);
    };
    GrpcClient.prototype.send = function (msg, header) {
        header = header || {};
        header['content-type'] = 'application/grpc-web+proto';
        header['x-grpc-web'] = '1';
        this.transport.sendMessage((0, bt_rpc_base_1.frameRequest)(msg.serializeBinary()), header);
    };
    GrpcClient.prototype.close = function () {
        if (!this.closed) {
            this.closed = true;
            this.debug_ && debug('request.abort aborting request');
            this.transport.cancel();
        }
        else {
            this.debug_ && debug('request.abort ignored, beacause the request already closed.');
        }
    };
    return GrpcClient;
}());
exports.GrpcClient = GrpcClient;
